/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://issue-tracking-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://issue-tracking-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/issue-tracking-tool-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
